import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * This component is used to be extended by other components which requires a subscription inside the implementation.
 * They can use "takeUntil(this.destroy$)" for their RxJS pipes to automatically clean them up after component is destroyed to avoid memory leaks.
 */
@Component({
	template: '',
})
export class BaseDestroy implements OnDestroy {
	protected readonly destroy$ = new Subject<void>();
	public ngOnDestroy() {
		// Cleanup logic
		this.destroy$.next();
		this.destroy$.complete();
	}
}
